import * as types from './types'
import to from '../../../helpers/to'
import * as userTypes from '../user/types'
import { functions, auth } from '@/services/firebase'

export default {
  [types.START_SUBSCRIPTION]: async function(store) {
    const state = store.state

    const callable = functions.httpsCallable('startPayment')
    return await to(callable(state))
  },

  [types.FREE_SUBSCRIPTION]: async function(store, payload) {
    const callable = functions.httpsCallable('freeSubscription')

    const [error, response] = await to(callable(payload))
    if (error) {
      return [error, null]
    }

    return [null, response]
  },
  [types.PROCEED_GIFT_PAYMENT]: async function(store, payload) {
    const callable = functions.httpsCallable('proceedGiftPayment')

    return await to(callable(payload))
  },
  [types.LOG_PAYMENT_ERROR]: async function(store, payload) {
    const callable = functions.httpsCallable('logPaymentError')
    await callable(payload)

    // Do nothing, it's just log, the endpoint return just acknowledged
  },
  // Check the user subscription status and set it in the store
  [types.CHECK_SUBSCRIPTION]: async function(store) {
    const userToken = await auth.currentUser.getIdToken(false)

    const callable = functions.httpsCallable('verifySubscriptionStatus')

    const [error, response] = await to(callable({ userToken }))
    if (error || response.data.error) {
      return [error, response]
    }

    // Server return the subscription type
    // Update the store now that the user is using trial
    store.commit(userTypes.SET_SUBSCRIPTION_STATUS, response.data.subscription)

    return [error, response]
  },
  [types.CANCEL_SUBSCRIPTION]: async function() {
    const userToken = await auth.currentUser.getIdToken(true)

    const callable = functions.httpsCallable('cancelSubscription')
    return await to(
      callable({
        userToken
      })
    )
  }
}
